export const BRANDS = {
  // default
  DHL: "__DHL-PATTERN-LIBRARY__",
  DPDHL: "__DPDHL-USER-LIBRARY__",
};
